<template>
  <page-table />
</template>
<script>
import PageTable from './components/order-table'
export default {
  name: 'order-changeRequest',
  components: {
    PageTable,
  },
}
</script>